import { useState } from "react";

export default function ScenarioGame({onComplete,color,dark,tier='builder'}){
  const STARTER_SCENARIOS=[
    {income:40,label:'Monthly Allowance',categories:[
      {id:'snacks',label:'🍦 Treats',max:20,clr:'#f59e0b'},
      {id:'fun',label:'🎮 Fun',max:15,clr:'#8b5cf6'},
      {id:'school',label:'📚 School',max:10,clr:'#0ea5e9'},
      {id:'save',label:'🐷 Save',max:20,clr:'#10b981'},
    ]},
    {income:20,label:'Weekly Allowance',categories:[
      {id:'snacks',label:'🍕 Snacks',max:8,clr:'#f59e0b'},
      {id:'fun',label:'🎬 Fun',max:8,clr:'#8b5cf6'},
      {id:'gifts',label:'🎁 Gifts',max:6,clr:'#ec4899'},
      {id:'save',label:'🐷 Save',max:10,clr:'#10b981'},
    ]},
  ];
  const BUILDER_SCENARIOS=[
    {income:400,label:'Part-Time Job',categories:[
      {id:'phone',label:'📱 Phone Bill',max:80,clr:'#0ea5e9'},
      {id:'food',label:'🍕 Food & Eating Out',max:120,clr:'#f59e0b'},
      {id:'fun',label:'🎮 Entertainment',max:100,clr:'#8b5cf6'},
      {id:'save',label:'🐷 Save',max:200,clr:'#10b981'},
    ]},
    {income:600,label:'Part-Time Job',categories:[
      {id:'transport',label:'🚗 Car Costs',max:200,clr:'#ef4444'},
      {id:'food',label:'🍎 Food',max:150,clr:'#f59e0b'},
      {id:'fun',label:'🎮 Fun',max:150,clr:'#8b5cf6'},
      {id:'save',label:'🐷 Save',max:250,clr:'#10b981'},
    ]},
  ];
  const MASTER_SCENARIOS=[
    {income:2000,label:'Monthly Paycheck',categories:[{id:'rent',label:'🏠 Rent',max:1200,clr:'#ef4444'},{id:'food',label:'🍎 Food',max:600,clr:'#f59e0b'},{id:'fun',label:'🎮 Fun',max:400,clr:'#8b5cf6'},{id:'save',label:'🐷 Save',max:500,clr:'#10b981'}]},
    {income:3500,label:'Monthly Paycheck',categories:[{id:'rent',label:'🏠 Rent',max:1800,clr:'#ef4444'},{id:'transport',label:'🚗 Car',max:600,clr:'#06b6d4'},{id:'food',label:'🍎 Food',max:600,clr:'#f59e0b'},{id:'save',label:'🐷 Save',max:800,clr:'#10b981'}]},
  ];
  const SCENARIOS=tier==='starter'?STARTER_SCENARIOS:tier==='master'?MASTER_SCENARIOS:BUILDER_SCENARIOS;
  const [sc]=useState(()=>SCENARIOS[Math.floor(Math.random()*SCENARIOS.length)]);
  const initVals=()=>{const v={};sc.categories.forEach(c=>v[c.id]=0);return v;};
  const [vals,setVals]=useState(initVals);
  const [submitted,setSubmitted]=useState(false);
  const totalSpent=Object.values(vals).reduce((a,b)=>a+b,0);
  const remaining=sc.income-totalSpent;
  const balanced=remaining===0;

  function change(id,v){setVals(prev=>({...prev,[id]:parseInt(v)}));}

  function submit(){
    if(!balanced)return;
    setSubmitted(true);
    setTimeout(onComplete,1300);
  }

  return(
    <div style={{fontFamily:'Nunito'}}>
      <p style={{fontSize:13,fontWeight:800,color:'#374151',textAlign:'center',marginBottom:4}}>
        🎮 Drag sliders to spend your whole paycheck — nothing left over!
      </p>
      {/* Income bar */}
      <div style={{background:`linear-gradient(135deg,${color},${dark})`,borderRadius:14,padding:'10px 14px',
        display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:12}}>
        <span style={{fontSize:14,fontWeight:900,color:'#fff'}}>💵 {sc.label}</span>
        <span style={{fontSize:18,fontWeight:900,color:'#fff'}}>${sc.income.toLocaleString()}</span>
      </div>
      {/* Category sliders */}
      {sc.categories.map(cat=>(
        <div key={cat.id} style={{marginBottom:12}}>
          <div style={{display:'flex',justifyContent:'space-between',marginBottom:4}}>
            <span style={{fontSize:13,fontWeight:800,color:dark}}>{cat.label}</span>
            <span style={{fontSize:13,fontWeight:900,color:cat.clr}}>${vals[cat.id]}</span>
          </div>
          <input type="range" min={0} max={cat.max} step={10} value={vals[cat.id]}
            onChange={e=>change(cat.id,e.target.value)}
            disabled={submitted}
            style={{width:'100%',accentColor:cat.clr,cursor:submitted?'not-allowed':'pointer'}}/>
          <div style={{fontSize:10,color:'#9ca3af',fontWeight:700}}>Max: ${cat.max}</div>
        </div>
      ))}
      {/* Remaining indicator */}
      <div style={{background:balanced?'#d1fae5':remaining<0?'#fee2e2':'#fef3c7',
        border:`2px solid ${balanced?'#10b981':remaining<0?'#ef4444':'#f59e0b'}`,
        borderRadius:12,padding:'10px 14px',textAlign:'center',marginBottom:10,transition:'all 0.2s'}}>
        <span style={{fontSize:15,fontWeight:900,color:balanced?'#065f46':remaining<0?'#991b1b':'#78350f'}}>
          {balanced?'✅ Budget balanced!':remaining<0?`❌ Over budget by $${Math.abs(remaining)}`:`💡 $${remaining} left to allocate`}
        </span>
      </div>
      {!submitted?(
        <button onClick={submit} disabled={!balanced} className="btn-bounce"
          style={{width:'100%',background:balanced?`linear-gradient(135deg,${color},${dark})`:'#d1d5db',
            border:'none',borderRadius:14,padding:'13px',fontSize:15,fontWeight:900,
            color:'#fff',cursor:balanced?'pointer':'not-allowed',transition:'all 0.3s'}}>
          {balanced?'Submit Budget! 💰':'Allocate all $'+sc.income+' first'}
        </button>
      ):(
        <div style={{textAlign:'center',padding:'12px',background:color+'15',borderRadius:14,border:`2px solid ${color}44`,animation:'pop 0.4s'}}>
          <div style={{fontSize:22,fontWeight:900,color:dark}}>🎉 Budget Complete!</div>
          <div style={{fontSize:13,color:'#6b7280',fontWeight:700}}>Great job managing ${sc.income}!</div>
        </div>
      )}
    </div>
  );
}
